import React, { useState } from 'react';
import Cookies from 'js-cookie';
import {
    Box,
    Typography,
    TextField,
    Button,
    Grid,
    Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import api from '../../../services/api';
import NavegadorGestao from "../../../components/NavBarGestao";

export default function CadastrarModulo() {
    const [loading, setLoading] = useState(false);
    const [dados, setDados] = useState({
        tipo: '',
        codigo: '',
        marca: '',
        modelo: '',
        data_fabricacao: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDados(prev => ({ ...prev, [name]: value }));
    };

    const handleSalvar = async () => {

        console.log("Dados: ", dados);

        if (!dados.tipo || !dados.codigo) {
            alert("Por favor, preencha o tipo e o código do módulo.");
            return;
        }
        
        if (!dados.marca || !dados.modelo || !dados.data_fabricacao) {
            alert("Por favor, preencha a marca, o modelo e a data de fabricação do módulo.");
            return;
        }

        setLoading(true);
        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            await api.post(`v1/protected/modulos/cadastrar?tipo=${dados.tipo}`, dados, { headers });

            alert("Módulo cadastrado com sucesso!");
            window.location.href = "/tecnica/modulos";
        } catch (_err) {
            console.error("Erro ao cadastrar módulo:", _err);
            alert("Erro ao cadastrar módulo. Verifique os dados e tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <NavegadorGestao
                AreaTecnica={true}
                Modulos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />

            <Box p={3}>
                <Box display="flex" alignItems="center" mb={3}>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => window.location.href = "/tecnica/modulos"}
                        sx={{ mr: 2 }}
                    >
                        Voltar
                    </Button>
                    <Typography variant="h5" fontWeight="bold">
                        Cadastrar Novo Módulo
                    </Typography>
                </Box>

                <Paper sx={{ p: 4, maxWidth: 800, mx: 'auto' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="tipo-label">Tipo de Módulo</InputLabel>
                                <Select
                                    labelId="tipo-label"
                                    name="tipo"
                                    value={dados.tipo}
                                    onChange={handleChange}
                                    label="Tipo de Módulo"
                                >
                                    <MenuItem value="ModuloPGM">ModuloPGM</MenuItem>
                                    <MenuItem value="ModuloGatewaySentinel">ModuloGatewaySentinel</MenuItem>
                                    <MenuItem value="ModuloSentinel">ModuloSentinel</MenuItem>
                                    <MenuItem value="ModuloSonoro">ModuloSonoro</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Código"
                                name="codigo"
                                value={dados.codigo}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Marca"
                                name="marca"
                                value={dados.marca}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Modelo"
                                name="modelo"
                                value={dados.modelo}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Data de Fabricação"
                                name="data_fabricacao"
                                type="date"
                                value={dados.data_fabricacao}
                                onChange={handleChange}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                                onClick={handleSalvar}
                                disabled={loading}
                                size="large"
                            >
                                {loading ? 'Salvando...' : 'Salvar Módulo'}
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </div>
    );
}
